import React, { useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useTheme, makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CloseIcon from '@material-ui/icons/Close';

import Loading from 'app/components/loaders/Loading';

import SavePaymentMethodForm from 'app/components/accounting/payments/SavePaymentMethodForm';

const stripePromise = loadStripe(process.env.MIX_STRIPE_KEY);

const useDialogStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    notActive: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        textAlign: 'center'
    },
    marginBottom: {
        marginBottom: theme.spacing(3)
    }
}));

export default function SavePaymentMethodDialog(props) {

    const { open, onClose, onClosed, onSave, user } = props;

    const theme = useTheme();

    const [ loading, setLoading ] = useState(false);

    const classes = useDialogStyles();

    const handleClosed = () => {
        setLoading(false);
        if (onClosed) onClosed();
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            onExited={handleClosed}
            fullScreen={useMediaQuery(theme.breakpoints.down('sm'))}
            aria-labelledby="form-edit-card"
            disableEnforceFocus //To allow stripe dialogs to work
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="form-edit-card">
                <span>Add New Payment Method</span>
                <IconButton
                    aria-label="Cancel"
                    className={classes.closeButton}
                    onClick={onClose}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {(stripePromise && user) ? (
                    <Elements stripe={stripePromise}>
                        <SavePaymentMethodForm
                            onSave={onSave}
                            user={user}
                            setLoading={setLoading}
                            loading={loading}
                        />
                    </Elements>
                ) : (
                    <Typography
                        className={classes.notActive}
                        variant="subtitle2"
                        color="error"
                        >
                        This organization has not enabled online payments. Please contact an organization administrator to find out how you can begin paying online.
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    )
}
